import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals } from 'helpers'
import cx from 'classnames'

import Modal from 'components/Modal/Modal'

import s from './ReportModal.scss'

import CommonReport from './CommonReport/CommonReport'
import TrainerReport from './TrainerReport/TrainerReport'
import PaymentReport from './PaymentReport/PaymentReport'
import PaymentReportByDate from './PaymentReportByDate/PaymentReportByDate'
import ServicesReport from './ServicesReport/ServicesReport'
import LearningReport from './LearningReport/LearningReport'
import FullToolsReport from './FullToolsReport/FullToolsReport'
import SubscribersReport from './SubscribersReport/SubscribersReport'


class ReportModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.Report,
  }

  close = () => {
    const { name } = this.props

    actions.modals.close(name)
  }

  render() {
    const {
      data: {
        to, from,
        statistic, statisticType,
        user,
        trainer,
        total, learnTotal, subscrTotal, schedTotal, paymentType,
      },
    } = this.props

    const isCommon      = Boolean(statisticType === 'common')
    const isServices    = Boolean(statisticType === 'services')
    const isSubscribers = Boolean(statisticType === 'subscribers')
    const isTrainer     = Boolean(statisticType === 'trainer')
    const isPayment     = Boolean(statisticType === 'payment')
    const isFullTools   = Boolean(statisticType === 'fullTools')
    const isLearning    = Boolean(statisticType === 'learning')
    const isPaymentByDate    = Boolean(statisticType === 'paymentByDate')
    
    const isEmpty = Boolean(!Object.keys(statistic.subscriptions ? statistic.subscriptions : statistic).length)
      || (isPaymentByDate && Object.keys(statistic.subscriptionsByDate).length === 0)

    const commonProps = {
      to,
      from,
      isEmpty,
      darkClassName: s.dark,
      titleClassName: s.title,
      buttonClassName: s.button,
      statistic,
      onClose: this.close,
    }

    return (
      <Modal
        className={cx(s.modal, {
          [s.size50]: isCommon || isSubscribers || isTrainer,
          [s.size100]: isServices,
        })}
        onClose={this.close}
      >
        <div className={s.container}>
          {
            isCommon && (
              <CommonReport
                {...commonProps}
                user={user}
              />
            )
          }
          {
            isSubscribers && (
              <SubscribersReport
                {...commonProps}
                darkestClassName={s.darkest}
              />
            )
          }
          {
            isTrainer && (
              <TrainerReport
                {...commonProps}
                trainer={trainer}
              />
            )
          }
          {
            isPayment && (
              <PaymentReport
                {...commonProps}
                darkestClassName={s.darkest}
                total={total}
                learnTotal={learnTotal}
                schedTotal={schedTotal}
                subscrTotal={subscrTotal}
                paymentType={paymentType}
              />
            )
          }          
          {
            isPaymentByDate && (
              <PaymentReportByDate
                {...commonProps}
                darkestClassName={s.darkest}
                total={total}
                learnTotal={learnTotal}
                schedTotal={schedTotal}
                subscrTotal={subscrTotal}
              />
            )
          }
          {
            isServices && (
              <ServicesReport
                {...commonProps}
                {...this.props.data}
              />
            )
          }
          {
            isFullTools && (
              <FullToolsReport
                {...commonProps}
                user={user}
              />
            )
          }
          {
            isLearning && (
              <LearningReport
                {...commonProps}
              />
            )
          }
        </div>
      </Modal>
    )
  }
}


export default ReportModal
